import React, { Children } from "react";
import { Flex, Card, Input, Pagination, Tabs } from "antd";
import { SwapOutlined, EditOutlined, EllipsisOutlined, ShoppingOutlined, BarcodeOutlined, LinkOutlined } from "@ant-design/icons";
import MyGoodsList from './my-list';
import CiteGoodsList from './my-proxy-list';
import can from '../../components/ability';

export default ({accId, shopId, onChange, ...others}) => {
    const [myGoods, setMyGoods] = React.useState([]);
    const [myGoodsCount, setMyGoodsCount] = React.useState(0);
    const [myProxyGoods, setMyProxyGoods] = React.useState([]);
    const [myProxyGoodsCount, setMyProxyGoodsCount] = React.useState(0);

    React.useEffect(() => {
        // loadProxyGoodsList();

        loadGoodsList();
    }, [shopId, accId]);

    const loadProxyGoodsList = (page = 1) => {
        getProxyGoodsList(page).then(res => {
            setMyProxyGoods(res.rows);
            setMyProxyGoodsCount(res.count);
        });
    }

    const loadGoodsList = (page = 1) => {
        getGoodsList(page).then(res => {
            setMyGoods(res.rows);
            onChange?.(res);
            setMyGoodsCount(res.count);
        });
    }

    const getGoodsList = async (page = 1) => {
        let response = await fetch(`/api/goods/my-list?accId=${accId}&shopId=${shopId}&page=${page}`);
        let result = await response.json();

        if(result.success){
            return result.data;
        }

        return [];
    }

    const getProxyGoodsList = async (page = 1) => {
        console.log('getProxyGoodsList', accId, shopId);
        let response = await fetch(`/api/goods/proxy-list?accId=${accId}&shopId=${shopId}&page=${page}`);
        let result = await response.json();

        if(result.success){
            // 修改数据字段名，是满足proxy-card组件的展示
            return result.data;
            // return result.data.map(({shopId_shops, ...others}) => ({...others, shopId_shop_goods_shops: shopId_shops}));
        }

        return [];
    }

    const onTabChange = (key, type) => {

        if(key === '1'){
            loadGoodsList();
        }else if(key === '2'){
            loadProxyGoodsList();
        }
    }

    const shopTabs = [
        {
             key: "1",
             label: "我的商品",
             children: <div>
                {/* <Input.Search placeholder="请输入商品名" style={{width: '100%', marginBottom: 10}} /> */}
                <MyGoodsList onStatusChange={() => loadGoodsList()} list={myGoods} accId={accId} {...others} />
                <Pagination defaultCurrent={1} total={myGoodsCount} onChange={(page) => loadGoodsList(page)} simple={{ readOnly: true }} />
            </div>
        },
        // {
        //      key: "2",
        //      label: "我代理的商品",
        //      children: 
        //         <div>
        //             <CiteGoodsList list={myProxyGoods} proxyClick={loadProxyGoodsList} proxyCancel={loadProxyGoodsList} />
        //             <Pagination defaultCurrent={1} total={myProxyGoodsCount} onChange={(page) => loadProxyGoodsList(page)} simple={{ readOnly: true }} />
        //         </div>
        // }
    ];

    if(can('proxy', 'goods')) {
        shopTabs.push({
            key: "2",
            label: "我代理的商品",
            children: 
                <div>
                    <CiteGoodsList list={myProxyGoods} proxyClick={loadProxyGoodsList} proxyCancel={loadProxyGoodsList} />
                    <Pagination defaultCurrent={1} total={myProxyGoodsCount} onChange={(page) => loadProxyGoodsList(page)} simple={{ readOnly: true }} />
                </div>
        })
    }

    return (
        <div>
            {/* <Divider /> */}
            {/* <Flex justify="space-between" align="center">
                <h3>爱帘说杭州店商品列表</h3>
                <div><SwapOutlined /> 切换店铺</div>
            </Flex> */}
            <Tabs defaultActiveKey="1" onChange={onTabChange} items={shopTabs} tabBarExtraContent={''} />
            
        </div>
    );
};
